import React, { useEffect, useState } from 'react'
import ImageGallery from 'react-image-gallery';
const URL = require('../../../../config/key').URL;

function ProductImage(props) {
    const [Images, setImages] = useState([])

    useEffect(() => {
        if (props.detail.images && props.detail.images.length > 0) {
            let images = [];

            props.detail.images && props.detail.images.map(item => {
                images.push({
                    original: `${URL}/${item}`,
                    thumbnail: `${URL}/${item}`
                })
            })
            setImages(images)
        }
    }, [props.detail])

    return (
        <div>
            <ImageGallery items={Images} />
        </div>
    )
}

export default ProductImage
